import { withStyles } from '@material-ui/core';

import Block from './component';
import styles from './styles';

export default withStyles(styles)(Block);
